import {
    validator_null_fb,
    validator_number_fb,
    validator_string_fb,
    validator_timestamp_fb,
    validator_typeOf_fb
} from "../../functions/src/shareCode/Share_S_Validator";
import {enum_typeof} from "../../functions/src/shareCode/Share_S_Enum";
import {initClass_f} from "../../functions/src/shareCode/Share_S_Classes";
import {date_getTimePastInSeconds_fn} from "@/scripts/S_Date";

export class FB_UserGeoLocation {

    _ugl_accuracy_n;

    constructor(FBObj) {

        initClass_f(
            'FB_UserGeoLocation',
            this,
            {
                ugl_userId_uid: {
                    oldNames_as: ["userId_uid"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.string)
                    }
                },
                ugl_altitude_n: {
                    oldNames_as: ["altitude_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_altitudeAccuracy_n: {
                    oldNames_as: ["altitudeAccuracy_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_heading_n: {
                    oldNames_as: ["heading_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_latitude_n: {
                    oldNames_as: ["latitude_n"],
                    val_f(val) {
                        return val != null ? val : 0
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_longitude_n: {
                    oldNames_as: ["longitude_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_speed_n: {
                    oldNames_as: ["speed_n"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
                ugl_timestamp_t: {
                    oldNames_as: ["timestamp_t"],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.number)
                    }
                },
            },
            FBObj)


        this.ugl_accuracy_n = FBObj._ugl_accuracy_n
    }

    set ugl_accuracy_n(val) {

        if (!validator_typeOf_fb(val, enum_typeof.number)) {
            console.log("set ugl_accuracy_n error")
            this._ugl_accuracy_n = 0;
            return;
        }

        this._ugl_accuracy_n = val

    }

    get ugl_accuracy_n() {
        if (this._ugl_accuracy_n > 400) {
            return 400
        }
        return this._ugl_accuracy_n

    }

}

export class FB_MapPlayerLocation {

    mpl_timestamp_t;
    mpl_secondsForOld_n;

    constructor(FBObj) {

        initClass_f(
            'FB_UserGeoLocation',
            this,
            {
                mpl_userId_uid: {
                    oldNames_as: [],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_typeOf_fb(val, enum_typeof.string)
                    }
                },
                mpl_username_s: {
                    oldNames_as: [],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_null_fb(val) || validator_string_fb(val)
                    }
                },
                mpl_dotColor_s: {
                    oldNames_as: [],
                    val_f(val) {
                        return val ? val : "green"
                    },
                    validator_f(val) {
                        return validator_string_fb(val)
                    }
                },
                mpl_latitude_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val != null ? val : 0
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                mpl_accuracy_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val != null ? (val < 400 ? val : 400) : 0
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                mpl_longitude_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
                mpl_timestamp_t: {
                    oldNames_as: [],
                    val_f(val) {
                        return val
                    },
                    validator_f(val) {
                        return validator_timestamp_fb(val)
                    }
                },
                mpl_secondsForOld_n: {
                    oldNames_as: [],
                    val_f(val) {
                        return val != null ? val : 5
                    },
                    validator_f(val) {
                        return validator_number_fb(val)
                    }
                },
            },
            FBObj)
    }

    cm_mpl_oldLocations_fb() {
        return date_getTimePastInSeconds_fn(this.mpl_timestamp_t) > this.mpl_secondsForOld_n
    }


}
